import { apiRequest } from '../../apiCall'


export const getWebsite = (params) => apiRequest('WebsiteDomain.GetWebsite', {},)
export const checkWebsite = (domain) => apiRequest('WebsiteDomain.CheckWebsite', { ...domain })
export const addWebsite = (params) => apiRequest('WebsiteDomain.AddWebsite', { ...params })
export const removeWebsite = (domainId) => apiRequest('WebsiteDomain.DeleteWebsite', {}, domainId)
export const updateStatusWebsite = (params) => apiRequest('WebsiteDomain.UpdateDomainStatus', { ...params })
export const getDomainGuidScriptRequest = (id) => apiRequest('WebsiteDomain.GuidScript', {}, id)
export const updateDomainAddress = (params) => apiRequest('WebsiteDomain.UpdateDomainAddress', { ...params })






